import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5722e3fa&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=5722e3fa&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true&external"
import style1 from "./index.vue?vue&type=style&index=1&id=5722e3fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5722e3fa",
  null
  
)

export default component.exports